import { Injectable } from '@angular/core';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';

interface DialogData {
  image: string;
  title: string;
  message: string;
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class ModalIntroService {
  constructor(private apiUsuario: ApiUsuarioService) {}

  public async getResearch() {
    return await this.apiUsuario.getResearch();
  }

  public async createResearchUri(researchUri: string): Promise<string> {
    const credentials = this.apiUsuario.getCredenciais();

    const customers = {
      customers: [
        {
          nome: credentials.nome,
          email: credentials.email,
          corretora: credentials.corretora,
          produto: 'Aggilizador Web',
          idfornecedor: credentials.assinaturaId ?? 0
        },
      ],
    };

    const result = await this.apiUsuario.postResearchUri(
      researchUri,
      customers
    );

    if (!result) return null;

    const url = result['customers']?.[0]?.['shortUrl'];

    return url ? url : null;
  }

  public async researchModal(): Promise<DialogData> {
    const content = await this.getResearch();

    if (!content) return null;

    const start = new Date(content['Inicio'] + 'T00:00:00-03:00');

    const end = new Date(content['Fim'] + 'T23:59:59-03:00');

    const today = new Date();

    if (today < start || today > end) return null;

    const uriPost = content['UrlPost'];

    const uriFixed = content['UrlFixa'];

    if (!uriPost && !uriFixed) return null;

    var resourceContent = uriPost
      ? await this.createResearchUri(uriPost)
      : uriFixed;

    if (!resourceContent) return null;

    const data: DialogData = {
      image: content['Imagem'],
      title: content['Titulo'],
      message: content['Mensagem'],
      url: resourceContent,
    };

    return data;
  }
}
